// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__HVYT2","col":"styles_col__2vUGC"};